import React, { useState } from 'react';
import Select from '../atoms/Select';
import Tag from '../atoms/Tag';
import FieldLabel from '../atoms/FieldLabel';

/**
 * Multi-select via dropdown + removable tags.
 */
export default function RoleMultiSelect({
  label = '',
  options = [],
  value = [],
  onChange,
  placeholder = 'Select roles',
  className = '',
}) {
  const [openValue, setOpenValue] = useState('');


  // console.log(value)
  const optionMap = new Map(
  options.map((opt) => {
    const optionValue = typeof opt === 'string' ? opt : opt.value;
    const optionLabel = typeof opt === 'string' ? opt : opt.label;

    return [String(optionValue), optionLabel];
  }),
);

const available = options.filter((opt) => {
  const val = typeof opt === 'string' ? opt : opt.value;

  return !value.some(
    (selectedValue) => String(selectedValue) === String(val)
  );
});
  const handleSelect = (e) => {
    const next = e.target.value;
    if (!next) return;
    onChange?.([...value, next]);
    setOpenValue('');
  };

  const handleRemove = (role) => {
    onChange?.(value.filter((r) => String(r) !== String(role)));
  };

  return (
    <div className={`ca-role-select ${className}`.trim()}>
      <FieldLabel>{label}</FieldLabel>
      <Select
        value={openValue}
        onChange={handleSelect}
        options={available}
        placeholder={placeholder}
      />
     {value.length > 0 ? (
  <div className="ca-tag-list">
    {[...new Set(value)].map((role) => (
      <Tag
        key={String(role)}
        label={optionMap.get(String(role)) || String(role)}
        onRemove={() => handleRemove(role)}
      />
    ))}
  </div>
) : null}
    </div>
  );
}
